// Musical timing helpers used by the creature state machine (960 PPQN, 4/4).
export { swingTick, unswingTick } from "@eb/shared";

export const PPQN = 960;
export const TICKS_PER_BAR = PPQN * 4;

export function ticksToMs(ticks: number, bpm: number): number {
  return (ticks * 60000) / (bpm * PPQN);
}

export function msToTicks(ms: number, bpm: number): number {
  return (ms * bpm * PPQN) / 60000;
}
